import { ViewLayoutContext } from 'v2/blocks/types'

export function determineIsBlockDisabled(block: Block, context: ViewLayoutContext) {
    if (block.type === 'container') return true

    return !context.editor.isEditing
}
